(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(84671);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 51199:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _meta_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53183);



var PageMetaHead = function(param) {
    var page_meta = param.page_meta, useExactTitle = param.useExactTitle;
    if (!page_meta) return null;
    var title = page_meta.title ? "".concat(_meta_config__WEBPACK_IMPORTED_MODULE_2__/* .APP_NAME */ .iC, " - ").concat(page_meta.title) : _meta_config__WEBPACK_IMPORTED_MODULE_2__/* .APP_NAME */ .iC;
    if (useExactTitle) {
        title = page_meta.title ? page_meta.title : _meta_config__WEBPACK_IMPORTED_MODULE_2__/* .APP_NAME */ .iC;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            page_meta.keywords && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: _meta_config__WEBPACK_IMPORTED_MODULE_2__/* .APP_META_KEYWORDS */ .FK
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }, "og:title"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: title
            }, "og:site_name"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: title
            }, "twitter:title"),
            page_meta.description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: page_meta.description
                    }, "description"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: page_meta.description
                    }, "og:description"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: page_meta.description
                    }, "twitter:description")
                ]
            }),
            page_meta.thumbnail && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: page_meta.thumbnail
                    }, "og:image"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image:secure_url",
                        content: page_meta.thumbnail
                    }, "og:image:secure_url"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:image",
                        content: page_meta.thumbnail
                    }, "twitter:image")
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PageMetaHead);


/***/ }),

/***/ 3022:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ getAllBlogPosts; }
/* harmony export */ });
/* unused harmony export getBlogPost */
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13223);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);


var getAllBlogPosts = function() {
    var page = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, per_page = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 10;
    return axios__WEBPACK_IMPORTED_MODULE_1___default().get("/blogs", {
        params: {
            page: page,
            per_page: per_page
        },
        baseURL: _config__WEBPACK_IMPORTED_MODULE_0__/* .httpConfig.baseURL */ .is.baseURL,
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
        }
    });
};
var getBlogPost = function(slug) {
    return axios.get("/blogs/get-blog-by-slug/".concat(slug), {
        baseURL: httpConfig.baseURL,
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
        }
    });
};


/***/ }),

/***/ 75945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CP": function() { return /* binding */ getCategories; },
/* harmony export */   "Dp": function() { return /* binding */ getSellerCategories; },
/* harmony export */   "gt": function() { return /* binding */ getChildrenCategories; },
/* harmony export */   "j5": function() { return /* binding */ getBuyerPurchasedCategories; },
/* harmony export */   "jA": function() { return /* binding */ getGroups; },
/* harmony export */   "k": function() { return /* binding */ getClasses; },
/* harmony export */   "qi": function() { return /* binding */ getLandingPageGroups; },
/* harmony export */   "yu": function() { return /* binding */ getTypes; },
/* harmony export */   "zY": function() { return /* binding */ getTreeCategories; }
/* harmony export */ });
/* unused harmony export getCategoryBySlug */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31176);


var getGroups = function(param) {
    var _environmentFilters = param.environmentFilters, environmentFilters = _environmentFilters === void 0 ? {} : _environmentFilters, filters = param.filters;
    return (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .request */ .WY)({
        method: "POST",
        url: "/product/catalog/products_services_tab",
        data: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
            filters: filters
        }, environmentFilters)
    });
};
var getLandingPageGroups = function() {
    return (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .request */ .WY)({
        method: "POST",
        url: "/product/catalog/products_services_tab",
        data: {
            filters: []
        },
        disableErrorMessage: true
    });
};
var getTreeCategories = function(parent_id) {
    var environmentFilters = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, filters = arguments.length > 2 ? arguments[2] : void 0, category_kind = arguments.length > 3 ? arguments[3] : void 0;
    return (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .request */ .WY)({
        url: "/getTreeCategories",
        method: "POST",
        data: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
            parent_id: parent_id,
            filters: filters,
            category_kind: category_kind
        }, environmentFilters)
    });
};
var getChildrenCategories = function(parent_id, page) {
    var environmentFilters = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, filters = arguments.length > 3 ? arguments[3] : void 0;
    return (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .request */ .WY)({
        url: "/getCategories",
        method: "POST",
        data: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
            parent_id: parent_id,
            page: page,
            filters: filters
        }, environmentFilters)
    });
};
var getCategories = function(param) {
    var page = param.page, search = param.search, _environmentFilters = param.environmentFilters, environmentFilters = _environmentFilters === void 0 ? {} : _environmentFilters, filters = param.filters;
    return (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .request */ .WY)({
        url: "/getCategories",
        method: "POST",
        data: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
            page: page,
            category_type: 1,
            query: search,
            filters: filters
        }, environmentFilters)
    });
};
var getClasses = function(param) {
    var page = param.page, search = param.search, _environmentFilters = param.environmentFilters, environmentFilters = _environmentFilters === void 0 ? {} : _environmentFilters, filters = param.filters;
    return (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .request */ .WY)({
        url: "/getCategories",
        method: "POST",
        data: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
            page: page,
            category_type: 2,
            query: search,
            filters: filters
        }, environmentFilters)
    });
};
var getTypes = function(param) {
    var page = param.page, search = param.search, _environmentFilters = param.environmentFilters, environmentFilters = _environmentFilters === void 0 ? {} : _environmentFilters, filters = param.filters;
    return (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .request */ .WY)({
        url: "/getCategories",
        method: "POST",
        data: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
            page: page,
            category_type: 3,
            query: search,
            filters: filters
        }, environmentFilters)
    });
};
var getSellerCategories = function(param) {
    var seller_id = param.seller_id, page = param.page, filtration_purpose = param.filtration_purpose;
    return (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .request */ .WY)({
        url: "/getCategories",
        method: "POST",
        data: {
            page: page,
            category_type: 1,
            filters: [
                {
                    type: "SELLER",
                    ids: [
                        seller_id
                    ]
                }
            ],
            filtration_purpose: filtration_purpose
        }
    });
};
var getCategoryBySlug = function(slug) {
    return request({
        url: "/product/categories/".concat(slug),
        method: "GET"
    });
};
var getBuyerPurchasedCategories = function(param) {
    var buyer_id = param.buyer_id, page = param.page;
    return (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .request */ .WY)({
        url: "/purchased-categories",
        method: "POST",
        data: {
            page: page,
            buyer_company_id: buyer_id
        }
    });
};


/***/ }),

/***/ 84671:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/logic/config/meta/PageMetaHead.tsx
var PageMetaHead = __webpack_require__(51199);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(93789);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Skeleton/Skeleton.js + 1 modules
var Skeleton = __webpack_require__(57412);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/umd/index.production.js
var index_production = __webpack_require__(3471);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-fast-marquee/dist/index.js
var dist = __webpack_require__(97005);
// EXTERNAL MODULE: ./src/logic/services/catalogue/classification/index.ts
var classification = __webpack_require__(75945);
// EXTERNAL MODULE: ./src/site-map.ts
var site_map = __webpack_require__(29951);
// EXTERNAL MODULE: ./src/ui/components/smart/landing/components/buttons/PrimaryButton.tsx
var PrimaryButton = __webpack_require__(82120);
;// CONCATENATED MODULE: ./src/ui/components/smart/landing/home/CategoriesSlider.tsx










var CategoriesSlider = function() {
    var data = (0,index_production.useQuery)({
        queryKey: [
            "LANDING_PAGE_GROUPS"
        ],
        queryFn: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,classification/* getLandingPageGroups */.qi)();
                    case 2:
                        data = _ctx.sent.data;
                        return _ctx.abrupt("return", data.items);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        })),
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        staleTime: Infinity,
        cacheTime: Infinity,
        retry: 1
    }).data;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            paddingBlock: "4rem"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                textAlign: "center",
                px: 1,
                fontSize: {
                    xs: 26,
                    lg: 44
                },
                fontWeight: 600,
                color: "#070A0D",
                maxWidth: "730px",
                mx: "auto",
                lineHeight: 1,
                component: "h2",
                children: [
                    "Over ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        style: {
                            color: "#005FCC"
                        },
                        children: "800 categories"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "of products and services"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    marginBlock: "2rem"
                },
                children: data ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                    autoFill: true,
                    pauseOnHover: true,
                    style: {
                        overflow: "hidden"
                    },
                    children: data.map(function(group) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            mr: 4,
                            display: "flex",
                            alignItems: "center",
                            gap: "0.5rem",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        width: "36px",
                                        height: "36px",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        borderRadius: "4px",
                                        backgroundColor: "#EFF1F3"
                                    },
                                    children: group.image_url ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: group.image_url,
                                        alt: group.name,
                                        width: "16px",
                                        height: "16px"
                                    }) : null
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    minWidth: "75px",
                                    maxWidth: "170px",
                                    noWrap: true,
                                    color: "#242833",
                                    fontWeight: 400,
                                    fontSize: {
                                        xs: 10,
                                        lg: 12
                                    },
                                    children: group.name
                                })
                            ]
                        }, group.id);
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                    autoFill: true,
                    pauseOnHover: true,
                    style: {
                        overflow: "hidden"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        variant: "rectangular",
                        width: "200px",
                        height: 36,
                        sx: {
                            borderRadius: "4px",
                            mr: 4
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: site_map.sm.catalogue.index.url,
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryButton/* default */.Z, {
                        sx: {
                            px: 4
                        },
                        children: "Discover Our Categories"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var home_CategoriesSlider = (CategoriesSlider);

;// CONCATENATED MODULE: ./src/ui/components/smart/landing/home/CategoriesSliderAsCards.tsx










var sliceGroupName = function(name) {
    var LENGTH = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 40;
    if (name.length < LENGTH) return name;
    return "".concat(name.slice(0, LENGTH), "...");
};
var CategoriesSliderAsCards = function() {
    var data = (0,index_production.useQuery)({
        queryKey: [
            "LANDING_PAGE_GROUPS"
        ],
        queryFn: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,classification/* getLandingPageGroups */.qi)();
                    case 2:
                        data = _ctx.sent.data;
                        return _ctx.abrupt("return", data.items);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        })),
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        staleTime: Infinity,
        cacheTime: Infinity,
        retry: 1
    }).data;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            paddingBlock: "4rem"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                textAlign: "center",
                px: 1,
                fontSize: {
                    xs: 26,
                    lg: 44
                },
                fontWeight: 600,
                color: "#070A0D",
                maxWidth: "730px",
                mx: "auto",
                lineHeight: 1,
                component: "h3",
                children: [
                    "One platform - ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        style: {
                            color: "#005FCC"
                        },
                        children: "Any industry"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                color: "#3C434A",
                lineHeight: 1.5,
                fontSize: {
                    xs: 12,
                    lg: 16
                },
                fontWeight: 400,
                textAlign: "center",
                maxWidth: "500px",
                mx: "auto",
                my: 4,
                px: 1,
                children: "Designed to support procurement needs in all sectors \u2014 from manufacturing to services"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: data ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                    autoFill: true,
                    pauseOnHover: true,
                    style: {
                        overflow: "hidden",
                        paddingBlock: "2rem"
                    },
                    children: data.map(function(group) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            mr: 4,
                            minHeight: "130px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-around",
                            flexDirection: "column",
                            gap: "0.5rem",
                            width: "250px",
                            sx: {
                                backgroundColor: "#fff",
                                boxShadow: "0px 0px 40px 0px #0017721A",
                                borderRadius: "20px",
                                p: 2
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        width: "44px",
                                        height: "44px"
                                    },
                                    children: group.image_url ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: group.image_url,
                                        alt: group.name,
                                        width: "44px",
                                        height: "44px"
                                    }) : null
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    textAlign: "center",
                                    color: "#3C434A",
                                    fontWeight: 400,
                                    fontSize: {
                                        xs: 12,
                                        lg: 16
                                    },
                                    lineHeight: 1.4,
                                    children: sliceGroupName(group.name)
                                })
                            ]
                        }, group.id);
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                    autoFill: true,
                    pauseOnHover: true,
                    style: {
                        overflow: "hidden"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        variant: "rectangular",
                        width: "250",
                        height: 130,
                        sx: {
                            borderRadius: "20px",
                            mr: 4
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: "1rem"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: site_map.sm.register.index.url,
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryButton/* default */.Z, {
                        sx: {
                            px: 8
                        },
                        children: "Get Started"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var home_CategoriesSliderAsCards = (CategoriesSliderAsCards);

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ExpandMore.js
var ExpandMore = __webpack_require__(23508);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Accordion/Accordion.js + 1 modules
var Accordion = __webpack_require__(76992);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/AccordionSummary/AccordionSummary.js + 1 modules
var AccordionSummary = __webpack_require__(29618);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/AccordionDetails/AccordionDetails.js + 1 modules
var AccordionDetails = __webpack_require__(47028);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/AutoFixHigh.js
var AutoFixHigh = __webpack_require__(40135);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Lan.js
var Lan = __webpack_require__(33293);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/QuestionAnswer.js
var QuestionAnswer = __webpack_require__(69606);
// EXTERNAL MODULE: ./src/logic/constants/links.ts
var links = __webpack_require__(84667);
;// CONCATENATED MODULE: ./src/ui/components/smart/landing/home/data.tsx






var pricingOptions = [
    {
        badge: "BUYERS",
        title: "Become a buyer",
        description: "Join a network of vetted sellers and streamline procurement - with 1% cashback on every confirmed order.",
        items: [
            "Just $50/month - cancel anytime",
            "1% cashback on all confirmed purchase orders",
            "First year FREE - launch with zero risk",
            "Priority onboarding and full support", 
        ],
        link: site_map.sm.register.asBuyer.index.url
    },
    {
        badge: "SELLER",
        title: "Become a seller",
        description: "List your products, close faster. Pay only when you win. Sell to a real buyers. Zero upfront cost.",
        items: [
            "Zero registration fees",
            "Zero listing fees",
            "Commission-only model - pay when you sell",
            "Discoverable by verified, high-intent buyers", 
        ],
        link: site_map.sm.register.asSeller.index.url
    }, 
];
// =============================================================
var intelligentProcurementItems = [
    {
        icon: Lan/* default */.Z,
        title: "Comprehensive Database for Seamless Automation",
        description: "eProcurement centralizes products, services, buyers, and sellers in a secure, integrated system. It automates procurement, reduces manual work, and speeds up sourcing\u2014ensuring data integrity and streamlined workflows so your team can focus on high-value tasks."
    },
    {
        icon: QuestionAnswer/* default */.Z,
        title: "Enhanced Collaboration Platform",
        description: "eProcurement acts as a central hub for communication between buyers and sellers, allowing for efficient collaboration throughout the procurement cycle. With built-in approval workflows and real-time updates , the platform ensures seamless interaction."
    },
    {
        icon: AutoFixHigh/* default */.Z,
        title: "AI-Driven Analytics Engine for Cost Savings",
        description: "eProcurement's powerful analytics engine goes beyond just tracking data \u2014 it identifies cost-saving opportunities by suggesting alternative products and services through intelligent AI recommendations by continuously analyzing usage patterns and market trends."
    }, 
];
// =============================================================
var faqItems = [
    {
        title: "What is eProcurement?",
        content: "eProcurement is an AI-powered, end-to-end sourcing and procurement platform that centralizes product and service catalogues, automates RFQs and POs, and provides real-time analytics to help you make smarter purchasing decisions."
    },
    {
        title: "How does eProcurement integrate with my existing systems?",
        content: "Our platform offers pre-built connectors and a robust API to seamlessly sync with ERPs, accounting software, and inventory management tools\u2014so you can plug in without disrupting your workflows."
    },
    {
        title: "What features are included?",
        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "Key features include:",
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    style: {
                        paddingInline: "1em",
                        marginBlock: 0
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: "Intelligent product search & AI-driven recommendations"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: "Automated RFQ and PO generation with dynamic comparison tables"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: "Document management (invoices, delivery notes)"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: "Audit-ready reporting and dashboards"
                        })
                    ]
                })
            ]
        })
    },
    {
        title: "How long does implementation take?",
        content: "Implementation is instantaneous once you register and get approved as a user. For larger integrations with ERP systems, our onboarding team guides you through data migration, configuration, and user training to ensure a smooth, speedy rollout."
    },
    {
        title: "Is my procurement data secure?",
        content: "Absolutely. We use AES-256 encryption at rest, TLS 1.2+ in transit, role-based access controls, and regular third-party security audits to safeguard your information."
    },
    {
        title: "What pricing plans do you offer?",
        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "We offer flexible, subscription-based pricing:",
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    style: {
                        paddingInline: "1em",
                        marginBlock: 0
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: "Buyers: $50 monthly fee \u2013 1% rebate on confirmed purchase orders."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: "Sellers: Zero listing fees, and 2 - 5% commission fees on sold items. Only pay when you sell."
                        })
                    ]
                })
            ]
        })
    },
    {
        title: "Can I manage multiple users and approval workflows?",
        content: "Yes. Define unlimited user roles, approval permissions to match your organization\u2019s structure\u2014ensuring compliance and accountability at every step."
    },
    {
        title: "How does the AI-driven recommendation engine work?",
        content: "Our AI continuously ingests and standardizes supplier catalogues and market benchmarks to suggest optimal products and suppliers\u2014helping you save time and maximize cost savings."
    },
    {
        title: "What kind of customer support is available?",
        content: "We provide 24/5 live chat, email support, and a dedicated Customer Success Manager for all users. You\u2019ll also have access to our online knowledge base and training webinars."
    },
    {
        title: "How do I get started with eProcurement?",
        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "Simply register online to start using eProcurement instantaneously.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "If you require additional guidance, book a free personalized demo on our website, or contact our sales team at",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: "mailto:".concat(links/* EMAIL */.xK),
                    className: "text-blue-600 underline",
                    children: links/* EMAIL */.xK
                }),
                ". We'll walk you through the platform, assess your needs, and outline next steps."
            ]
        })
    }, 
];
var procurementOverviewItems = [
    {
        badges: [
            "Cloud Solution"
        ],
        title: "Cloud-Based Convenience",
        description: "Access your procurement solution anywhere, anytime. As a cloud-based platform, eProcurement offers flexibility, scalability, and zero downtime, enabling your team to work remotely or across multiple locations without the need for complex installations or infrastructure.",
        image: "/assets/images/procurement-overview/cloud-based-convenience.png"
    },
    {
        badges: [
            "AI-powered"
        ],
        title: "AI-Powered Automation & Real-Time Analytics",
        description: "Harness the power of AI to automate your procurement processes, from product selection to purchase order creation. Real-time analytics provide actionable insights into your spend, helping you make data-driven decisions with ease and optimize procurement workflows for maximum efficiency.",
        image: "/assets/images/procurement-overview/ai-automation-analytics.png"
    },
    {
        badges: [
            "Scale"
        ],
        title: "Supplier Management & Document Centre ",
        description: "Manage suppliers seamlessly with eProcurement\u2019s robust supplier management tools. Store and organize all procurement documents in one secure, centralized location. Enjoy direct connectivity between buyers and sellers for efficient collaboration and streamlined transactions.",
        image: "/assets/images/procurement-overview/supplier-management-docs.png"
    },
    {
        badges: [
            "Integrations",
            "Coming Soon"
        ],
        title: "ERP System Integration",
        description: "Easily integrate eProcurement with your existing ERP systems, including QuickBooks, SAP, Oracle, and Sage. Our seamless connectivity ensures a smooth flow of data across platforms, eliminating manual data entry, minimizing errors, and ensuring consistency across your entire tech ecosystem.",
        image: "/assets/images/procurement-overview/erp-integration.png"
    }, 
];

;// CONCATENATED MODULE: ./src/ui/components/smart/landing/home/Faq.tsx




var Faq = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "page__content",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            sx: {
                py: 8,
                maxWidth: "700px",
                mx: "auto"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    textAlign: "center",
                    fontSize: {
                        xs: 26,
                        lg: 44
                    },
                    fontWeight: 600,
                    color: "#070A0D",
                    lineHeight: 1,
                    mb: 3,
                    component: "h3",
                    children: "FAQ"
                }),
                faqItems.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default */.Z, {
                        defaultExpanded: index === 0,
                        disableGutters: true,
                        sx: {
                            borderBottom: "1px solid #EBEBEB",
                            boxShadow: "none",
                            py: 2
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionSummary/* default */.Z, {
                                expandIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandMore/* default */.Z, {}),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    fontWeight: 500,
                                    fontSize: {
                                        xs: 15,
                                        lg: 16
                                    },
                                    color: "#3A3E50",
                                    lineHeight: 1.25,
                                    component: "h5",
                                    children: item.title
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionDetails/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "body2",
                                    component: "div",
                                    color: "#8D91A0",
                                    children: item.content
                                })
                            })
                        ]
                    }, index);
                })
            ]
        })
    });
};
/* harmony default export */ var home_Faq = (Faq);

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(79072);
// EXTERNAL MODULE: ./src/logic/services/blog/index.ts
var blog = __webpack_require__(3022);
// EXTERNAL MODULE: ./src/ui/components/smart/landing/blog/BlogPostCard.tsx
var BlogPostCard = __webpack_require__(87333);
;// CONCATENATED MODULE: ./src/ui/components/smart/landing/home/HomeBlogPosts.tsx










var MAX_POSTS = 3;
var HomeBlogPosts = function() {
    var ref;
    var data = (0,index_production.useQuery)({
        queryKey: [
            "LANDING_PAGE_BLOG_POSTS"
        ],
        queryFn: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,blog/* getAllBlogPosts */.S)(1, MAX_POSTS);
                    case 2:
                        data = _ctx.sent.data;
                        return _ctx.abrupt("return", data.data);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        })),
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        staleTime: Infinity,
        cacheTime: Infinity,
        retry: 1
    }).data;
    var posts = data === null || data === void 0 ? void 0 : data.data;
    var hasMore = !!(data === null || data === void 0 ? void 0 : (ref = data.meta) === null || ref === void 0 ? void 0 : ref.total) && data.meta.total > MAX_POSTS;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "page__content",
        style: {
            paddingBlock: "4rem"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                textAlign: "center",
                px: 1,
                fontSize: {
                    xs: 26,
                    lg: 44
                },
                fontWeight: 600,
                color: "#070A0D",
                mx: "auto",
                lineHeight: 1,
                component: "h3",
                maxWidth: "17ch",
                children: [
                    "Stay Updated With ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        style: {
                            color: "#005FCC"
                        },
                        children: "Our Latest Posts"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    container: true,
                    spacing: 2,
                    py: 2,
                    children: posts ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: posts.map(function(post) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                xs: 12,
                                sm: 6,
                                md: 4,
                                lg: 4,
                                xl: 4,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogPostCard/* default */.Z, {
                                    post: post
                                })
                            }, post.id);
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: [
                            1,
                            2,
                            3
                        ].map(function(num) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                xs: 12,
                                sm: 6,
                                md: 4,
                                lg: 4,
                                xl: 4,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                    variant: "rectangular",
                                    width: "100%",
                                    height: 300,
                                    sx: {
                                        borderRadius: "20px",
                                        mr: 4
                                    }
                                })
                            }, num);
                        })
                    })
                })
            }),
            hasMore && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: "1rem"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: site_map.sm.blog.index.url,
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryButton/* default */.Z, {
                        sx: {
                            px: 8
                        },
                        children: "More Posts"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var home_HomeBlogPosts = (HomeBlogPosts);

// EXTERNAL MODULE: ./src/logic/config/index.ts + 38 modules
var config = __webpack_require__(13223);
// EXTERNAL MODULE: ./src/logic/zustand/index.ts + 16 modules
var zustand = __webpack_require__(14398);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/PlayArrow.js
var PlayArrow = __webpack_require__(58989);
;// CONCATENATED MODULE: ./src/ui/components/smart/landing/home/HomeHero.tsx








var HomeHero = function() {
    var isAuthenticated = (0,zustand/* useUserData */.v$)(function(state) {
        return state.authenticationStatus === config/* AuthenticateStatus.AUTHENTICATED */.xE.AUTHENTICATED;
    });
    var isInitializing = (0,zustand/* useUserData */.v$)(function(state) {
        return state.isInitializing;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        py: 8,
        style: {
            background: "linear-gradient(90deg, rgba(0, 149, 255, 0.05) 0%, rgba(111, 255, 0, 0.05) 49.04%, rgba(115, 0, 255, 0.05) 100%), linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%)"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "page__content",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                container: true,
                alignItems: "center",
                spacing: 5,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 6,
                        xl: 6,
                        item: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                fontSize: {
                                    xs: 8,
                                    lg: 12
                                },
                                fontWeight: 700,
                                textTransform: "uppercase",
                                color: "#fff",
                                sx: {
                                    backgroundColor: "#0F5D85",
                                    display: "inline-block",
                                    borderRadius: "10px",
                                    p: 1,
                                    letterSpacing: "1px"
                                },
                                children: "Procurement software"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                my: 2,
                                color: "#070A0D",
                                fontWeight: 600,
                                component: "h1",
                                fontSize: {
                                    xs: 40,
                                    lg: 64
                                },
                                lineHeight: 0.9,
                                children: "Smarter Procurement"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                my: 2,
                                color: "#1D2935",
                                fontWeight: 400,
                                fontSize: {
                                    xs: 12,
                                    lg: 16
                                },
                                lineHeight: 1.5,
                                maxWidth: "450px",
                                children: "One platform to automate, analyze, and scale your entire procurement process. AI-powered. Supplier-connected. Globally scalable."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                display: "flex",
                                flexWrap: "wrap",
                                gap: 1,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: isAuthenticated ? site_map.sm.portals.index.url : site_map.sm.register.index.url,
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryButton/* default */.Z, {
                                            sx: {
                                                px: {
                                                    xs: 4.5,
                                                    lg: 8
                                                },
                                                py: 2.25,
                                                border: "2px solid #005FCC"
                                            },
                                            disabled: isInitializing,
                                            children: "Get Started"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "#how-it-works",
                                        passHref: true,
                                        scroll: false,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryButton/* default */.Z, {
                                            sx: {
                                                px: {
                                                    xs: 2,
                                                    lg: 5.5
                                                },
                                                py: 2.25,
                                                backgroundColor: "transparent",
                                                border: "2px solid #005FCC",
                                                color: "#005FCC",
                                                "&:hover": {
                                                    backgroundColor: "transparent"
                                                }
                                            },
                                            variant: "text",
                                            startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayArrow/* default */.Z, {}),
                                            children: "How It Works?"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 6,
                        xl: 6,
                        item: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                position: "relative",
                                width: "100%",
                                maxWidth: "600px",
                                height: "auto",
                                aspectRatio: "1428 / 960",
                                borderRadius: "20px",
                                border: "15px solid #000",
                                boxShadow: "0px 0px 40px 0px #0017721A",
                                overflow: "hidden"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                                src: "/assets/videos/hero-intro.mp4",
                                muted: true,
                                autoPlay: true,
                                loop: true,
                                playsInline: true,
                                style: {
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                    display: "block",
                                    borderRadius: "10px"
                                }
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var home_HomeHero = (HomeHero);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/SellOutlined.js
var SellOutlined = __webpack_require__(74957);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ShoppingCartOutlined.js
var ShoppingCartOutlined = __webpack_require__(46624);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Button/Button.js + 1 modules
var Button = __webpack_require__(54225);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Pause.js
var Pause = __webpack_require__(53247);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/react-intersection-observer.m.js
var react_intersection_observer_m = __webpack_require__(70131);
;// CONCATENATED MODULE: ./src/ui/components/smart/landing/home/videos-section/source.ts
var VIDEOS = {
    buyer: [
        {
            id: "buyer-1",
            title: "Buyer Workflow Integrated",
            thumbnail: "/assets/images/home/BuyerWorkflow_Thumbnail_1.png",
            video: "/assets/videos/BuyerWorkflow_Video_1.mp4",
            duration: "02:34"
        },
        {
            id: "buyer-2",
            title: "Smart Requisition Start",
            thumbnail: "/assets/images/home/BuyerWorkflow_Thumbnail_2.png",
            video: "/assets/videos/BuyerWorkflow_Video_2.mp4",
            duration: "02:26"
        },
        {
            id: "buyer-3",
            title: "Intelligent Product Directory",
            thumbnail: "/assets/images/home/BuyerWorkflow_Thumbnail_3.png",
            video: "/assets/videos/BuyerWorkflow_Video_3.mp4",
            duration: "01:01"
        },
        {
            id: "buyer-4",
            title: "Receiving Quotes Faster",
            thumbnail: "/assets/images/home/BuyerWorkflow_Thumbnail_4.png",
            video: "/assets/videos/BuyerWorkflow_Video_4.mp4",
            duration: "01:20"
        },
        {
            id: "buyer-5",
            title: "Projects Overview",
            thumbnail: "/assets/images/home/BuyerWorkflow_Thumbnail_5.png",
            video: "/assets/videos/BuyerWorkflow_Video_5.mp4",
            duration: "01:01"
        },
        {
            id: "buyer-6",
            title: "Effortless Account Management",
            thumbnail: "/assets/images/home/BuyerWorkflow_Thumbnail_6.png",
            video: "/assets/videos/BuyerWorkflow_Video_6.mp4",
            duration: "00:44"
        },
        {
            id: "buyer-7",
            title: "Smarter Suppliers Management",
            thumbnail: "/assets/images/home/BuyerWorkflow_Thumbnail_7.png",
            video: "/assets/videos/BuyerWorkflow_Video_7.mp4",
            duration: "01:14"
        }, 
    ],
    seller: [
        {
            id: "seller-1",
            title: "Seller Workflow Integrated",
            thumbnail: "/assets/images/home/SellerWorkflow_Thumbnail_1.png",
            video: "/assets/videos/SellerWorkflow_Video_1.mp4",
            duration: "02:19"
        },
        {
            id: "seller-2",
            title: "Account & Access Control",
            thumbnail: "/assets/images/home/SellerWorkflow_Thumbnail_2.png",
            video: "/assets/videos/SellerWorkflow_Video_2.mp4",
            duration: "00:53"
        },
        {
            id: "seller-3",
            title: "Smarter Buyers Management",
            thumbnail: "/assets/images/home/SellerWorkflow_Thumbnail_3.png",
            video: "/assets/videos/SellerWorkflow_Video_3.mp4",
            duration: "01:33"
        },
        {
            id: "seller-4",
            title: "Projects Control",
            thumbnail: "/assets/images/home/SellerWorkflow_Thumbnail_4.png",
            video: "/assets/videos/SellerWorkflow_Video_4.mp4",
            duration: "01:06"
        }, 
    ]
};

;// CONCATENATED MODULE: ./src/ui/components/smart/landing/home/videos-section/videosList.tsx





var ScrollableVideos = function(param) {
    var videos = param.videos, activeVideoId = param.activeVideoId, playingVideoId = param.playingVideoId, onSelect = param.onSelect, height = param.height;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: {
            borderRadius: "16px",
            boxShadow: "0 0 12px rgba(0,0,0,0.3)",
            backgroundColor: {
                xs: "#F6F8FD",
                md: "#fff"
            },
            height: {
                xs: "100%",
                md: height || "100%"
            },
            padding: 1
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            sx: {
                display: "flex",
                flexDirection: {
                    xs: "row",
                    md: "column"
                },
                gap: 1,
                height: "100%",
                width: "100%",
                overflowX: {
                    xs: "auto",
                    md: "hidden"
                },
                overflowY: {
                    xs: "hidden",
                    md: "auto"
                },
                borderRadius: "16px",
                overflow: "hidden",
                scrollSnapType: {
                    xs: "x mandatory",
                    md: undefined
                },
                scrollPadding: "8px",
                paddingRight: {
                    xs: 0,
                    md: 1
                },
                WebkitOverflowScrolling: "touch",
                "&::-webkit-scrollbar": {
                    display: {
                        xs: "none",
                        md: "block"
                    }
                },
                "-ms-overflow-style": {
                    xs: "none",
                    md: "auto"
                },
                "scrollbar-width": {
                    xs: "none",
                    md: "auto"
                }
            },
            className: "styled-scrollbar",
            children: videos.map(function(video) {
                var isActive = video.id === activeVideoId;
                var isPlaying = video.id === playingVideoId;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    sx: {
                        flex: {
                            xs: "0 0 140px",
                            md: "0 0 auto"
                        },
                        mb: 1,
                        scrollSnapAlign: {
                            xs: "start",
                            md: undefined
                        },
                        p: 1,
                        borderRadius: "8px",
                        boxShadow: "0px 1px 8px rgba(0,0,0,0.2)",
                        border: "1px solid rgba(0,0,0,0.05)",
                        cursor: "pointer",
                        width: {
                            xs: "140px",
                            md: "100%"
                        },
                        position: "relative",
                        backgroundColor: {
                            xs: "#fff",
                            md: isActive ? "#CCD8E6" : "#fff"
                        },
                        WebkitTapHighlightColor: "transparent"
                    },
                    onClick: function() {
                        return onSelect(video);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            sx: {
                                position: "relative",
                                width: "100%",
                                paddingTop: "56.25%",
                                borderRadius: "8px",
                                overflow: "hidden"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: video.thumbnail,
                                    alt: video.title,
                                    style: {
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                        borderRadius: "8px",
                                        position: "absolute",
                                        top: 0,
                                        left: 0
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    sx: {
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        width: "100%",
                                        height: "100%",
                                        borderRadius: "8px",
                                        backgroundColor: isActive ? "rgba(0, 0, 0, 0.5)" : "rgba(164, 154, 154, 0.1)"
                                    }
                                }),
                                isActive && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    component: "button",
                                    onClick: function(e) {
                                        e.stopPropagation();
                                        onSelect(video);
                                    },
                                    sx: {
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        color: "#fff",
                                        backgroundColor: "#000",
                                        border: "3px solid rgba(221, 218, 218, 0.3)",
                                        boxShadow: "0 0 8px rgba(0, 0, 0, 0.6)",
                                        borderRadius: "25px",
                                        cursor: "pointer",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        padding: {
                                            xs: "0.1rem 0rem",
                                            md: "0.3rem 0.2rem"
                                        },
                                        gap: 0.5,
                                        width: "80%",
                                        WebkitTapHighlightColor: "transparent"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "subtitle2",
                                            fontWeight: 600,
                                            fontSize: {
                                                xs: "9px",
                                                md: "9.5px",
                                                lg: "12px"
                                            },
                                            children: isPlaying ? "Now Playing" : "Click to Play"
                                        }),
                                        isPlaying ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Pause/* default */.Z, {
                                            sx: {
                                                fontSize: {
                                                    xs: "0.7rem",
                                                    md: "0.6rem",
                                                    lg: "1rem"
                                                }
                                            }
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayArrow/* default */.Z, {
                                            sx: {
                                                fontSize: {
                                                    xs: "0.7rem",
                                                    md: "0.6rem",
                                                    lg: "1rem"
                                                }
                                            }
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            sx: {
                                mt: 1,
                                pl: 0.5,
                                minHeight: 20
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "body2",
                                    fontWeight: 600,
                                    fontSize: {
                                        xs: "9.5px",
                                        md: "11.5px",
                                        lg: "13px"
                                    },
                                    lineHeight: "1.3em",
                                    sx: {
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        height: "1.3em",
                                        color: "#1D2935"
                                    },
                                    children: video.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "subtitle2",
                                    fontWeight: 400,
                                    fontSize: {
                                        xs: "8px",
                                        md: "11px",
                                        lg: "12px"
                                    },
                                    pt: 0.5,
                                    color: "#3A5269",
                                    children: video.duration
                                })
                            ]
                        })
                    ]
                }, video.id);
            })
        })
    });
};
/* harmony default export */ var videosList = (ScrollableVideos);

;// CONCATENATED MODULE: ./src/ui/components/smart/landing/home/videos-section/index.tsx









var VideosSection = function(param) {
    var selectedOption = param.selectedOption;
    var ref = (0,react_intersection_observer_m/* useInView */.YD)({
        threshold: 0.5
    }), inViewRef = ref.ref, inView = ref.inView;
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(null), 2), activeVideo = ref1[0], setActiveVideo = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), play = ref2[0], setPlay = ref2[1];
    var videoRef = react.useRef(null);
    var ref3 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), showVideo = ref3[0], setShowVideo = ref3[1];
    var videoContainerRef = react.useRef(null);
    var ref4 = (0,_sliced_to_array/* default */.Z)(react.useState(0), 2), videoHeight = ref4[0], setVideoHeight = ref4[1];
    var videos = VIDEOS[selectedOption];
    react.useEffect(function() {
        if (videos.length > 0) {
            setActiveVideo(videos[0]);
            setShowVideo(false);
            setPlay(false);
        }
    }, [
        selectedOption
    ]);
    var playVideo = function() {
        var ref;
        (ref = videoRef.current) === null || ref === void 0 ? void 0 : ref.play();
        setShowVideo(true);
        setPlay(true);
    };
    var pauseVideo = function() {
        var ref;
        (ref = videoRef.current) === null || ref === void 0 ? void 0 : ref.pause();
        setShowVideo(false);
        setPlay(false);
    };
    var toggleVideo = function() {
        if (!showVideo) playVideo();
        else play ? pauseVideo() : playVideo();
    };
    var handleSelectVideo = function(video) {
        setActiveVideo(video);
        toggleVideo();
    };
    react.useEffect(function() {
        if (!inView && videoRef.current) {
            videoRef.current.pause();
            videoRef.current.currentTime = 0;
            setPlay(false);
            setShowVideo(false);
        }
    }, [
        inView
    ]);
    react.useEffect(function() {
        var updateHeight = function() {
            if (videoContainerRef.current) {
                setVideoHeight(videoContainerRef.current.offsetHeight);
            }
        };
        updateHeight();
        window.addEventListener("resize", updateHeight);
        return function() {
            return window.removeEventListener("resize", updateHeight);
        };
    }, [
        activeVideo
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        container: true,
        gap: 2,
        justifyContent: "center",
        flexWrap: "wrap",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                md: 7,
                lg: 7,
                sx: {
                    position: "relative",
                    minWidth: 300,
                    maxWidth: 900,
                    height: "100%"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    ref: function(el) {
                        inViewRef(el);
                        videoContainerRef.current = el;
                    },
                    sx: {
                        position: "relative",
                        borderRadius: "16px",
                        width: "100%",
                        boxShadow: "0 0 12px rgba(0, 0, 0, 0.3)",
                        paddingTop: "56.25%",
                        overflow: "hidden"
                    },
                    children: [
                        activeVideo && (showVideo ? /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                            ref: videoRef,
                            src: activeVideo.video,
                            controls: true,
                            muted: true,
                            loop: true,
                            autoPlay: true,
                            playsInline: true,
                            style: {
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                borderRadius: "16px"
                            }
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: activeVideo.thumbnail,
                            alt: activeVideo.title,
                            style: {
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                borderRadius: "16px",
                                boxShadow: "0 0 12px rgba(0, 0, 0, 0.3)"
                            }
                        })),
                        activeVideo && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            component: "button",
                            onClick: function(e) {
                                e.stopPropagation();
                                toggleVideo();
                            },
                            sx: {
                                position: "absolute",
                                top: {
                                    lg: "48%",
                                    md: "47%",
                                    xs: "45%"
                                },
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                color: "#fff",
                                backgroundColor: "#000",
                                border: "3px solid rgba(221, 218, 218, 0.3)",
                                boxShadow: "0 0 8px rgba(0, 0, 0, 0.6)",
                                borderRadius: "50%",
                                cursor: "pointer",
                                width: "65px",
                                height: "65px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                fontSize: "32px",
                                WebkitTapHighlightColor: "transparent",
                                outline: "none"
                            },
                            children: play ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Pause/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayArrow/* default */.Z, {})
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                md: 2.5,
                lg: 2.5,
                height: "100%",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(videosList, {
                    videos: videos,
                    activeVideoId: (activeVideo === null || activeVideo === void 0 ? void 0 : activeVideo.id) || null,
                    playingVideoId: play && activeVideo ? activeVideo.id : null,
                    onSelect: handleSelectVideo,
                    height: videoHeight
                })
            })
        ]
    });
};
/* harmony default export */ var videos_section = (VideosSection);

;// CONCATENATED MODULE: ./src/ui/components/smart/landing/home/HowItWorks.tsx







var options = [
    {
        value: "buyer",
        title: "Watch Buyers Flow",
        icon: ShoppingCartOutlined/* default */.Z
    },
    {
        value: "seller",
        title: "Watch Sellers Flow",
        icon: SellOutlined/* default */.Z
    }, 
];
var HowItWorks = function() {
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(options[0]), 2), selectedOption = ref[0], setSelectedOption = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        my: 3,
        px: 2,
        py: 6,
        style: {
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    width: {
                        xs: "calc(100% - 10px)",
                        lg: "calc(100% - 100px)"
                    },
                    height: "60%",
                    mx: "auto",
                    borderRadius: {
                        xs: "12px",
                        lg: "24px"
                    },
                    position: "absolute",
                    top: 0,
                    left: "50%",
                    transform: "translateX(-50%)",
                    backgroundColor: "#005FCC",
                    backgroundImage: 'url("/assets/images/home/gradient.png")',
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    zIndex: 1
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    position: "relative",
                    zIndex: 2
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        color: "#fff",
                        fontWeight: 600,
                        fontSize: {
                            xs: 26,
                            lg: 44
                        },
                        textAlign: "center",
                        px: 2,
                        mb: 2,
                        lineHeight: 1,
                        component: "h2",
                        children: "See It in Action"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        color: "#EFF6FF",
                        lineHeight: 1.5,
                        fontSize: {
                            xs: 12,
                            lg: 16
                        },
                        fontWeight: 400,
                        textAlign: "center",
                        maxWidth: "600px",
                        mx: "auto",
                        mb: 2,
                        px: 2,
                        children: "Watch how buyers streamline purchasing and sellers accelerate fulfillment using our platform."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            maxWidth: "fit-content",
                            mx: "auto",
                            backgroundColor: "#003C83",
                            borderRadius: "20px",
                            p: 1
                        },
                        display: "flex",
                        gap: 1,
                        mb: 2.5,
                        children: options.map(function(opt) {
                            var isSelected = opt.value === selectedOption.value;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                type: "button",
                                onClick: function() {
                                    if (!isSelected) {
                                        setSelectedOption(opt);
                                    }
                                },
                                startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(opt.icon, {}),
                                sx: {
                                    borderRadius: "10px",
                                    px: 2,
                                    py: 2.5,
                                    lineHeight: 1.25,
                                    color: isSelected ? "#1B425D" : "#fff",
                                    fontWeight: isSelected ? 800 : 400,
                                    fontSize: {
                                        sm: 12,
                                        lg: 15
                                    },
                                    backgroundColor: isSelected ? "#fff" : "transparent",
                                    "&:hover": {
                                        backgroundColor: isSelected ? "#fff" : "transparent"
                                    }
                                },
                                children: opt.title
                            });
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            mx: "auto",
                            width: {
                                xs: "calc(100% - 10px)",
                                lg: "calc(100% - 100px)"
                            },
                            borderRadius: {
                                xs: "12px",
                                lg: "24px"
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(videos_section, {
                            selectedOption: selectedOption.value
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var home_HowItWorks = (HowItWorks);

;// CONCATENATED MODULE: ./src/ui/components/smart/landing/home/IntelligentProcurement.tsx



var IntelligentProcurement = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            paddingBlock: "1rem"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "page__content",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                    color: "#3A3E50",
                    fontWeight: 600,
                    fontSize: {
                        xs: 26,
                        lg: 44
                    },
                    textAlign: "center",
                    mb: 4,
                    mx: "auto",
                    maxWidth: "30ch",
                    lineHeight: 1,
                    component: "h2",
                    children: [
                        "Everything You Need for ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            style: {
                                color: "#005FCC"
                            },
                            children: "Intelligent Procurement"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    position: "relative"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            display: {
                                xs: "none",
                                sm: "none",
                                md: "block",
                                lg: "block",
                                xl: "block"
                            },
                            width: "100%",
                            height: "64px",
                            position: "absolute",
                            left: 0,
                            top: "50%",
                            transform: "translateY(-50%)",
                            backgroundColor: "#0067E2",
                            zIndex: 1
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "page__content",
                        style: {
                            position: "relative",
                            zIndex: 2
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            container: true,
                            spacing: {
                                xs: 1,
                                lg: 3
                            },
                            children: intelligentProcurementItems.map(function(item) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    item: true,
                                    xs: 12,
                                    sm: 12,
                                    md: 4,
                                    lg: 4,
                                    xl: 4,
                                    pb: 2,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                        sx: {
                                            boxShadow: "0px 0px 40px 0px #0017721A",
                                            backgroundColor: "#fff",
                                            p: 2,
                                            borderRadius: "20px",
                                            height: "100%"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 1,
                                                mb: 1,
                                                color: "#070A0D",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(item.icon, {
                                                        sx: {
                                                            fontSize: 44
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        fontWeight: 600,
                                                        fontSize: {
                                                            xs: 14,
                                                            lg: 18
                                                        },
                                                        lineHeight: 1.2,
                                                        maxWidth: "25ch",
                                                        component: "h3",
                                                        children: item.title
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                color: "#1D2935",
                                                fontWeight: 400,
                                                fontSize: {
                                                    xs: 12,
                                                    lg: 16
                                                },
                                                lineHeight: 1.5,
                                                children: item.description
                                            })
                                        ]
                                    })
                                }, item.title);
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var home_IntelligentProcurement = (IntelligentProcurement);

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/ui/components/smart/landing/home/PricingOptions.tsx






var PricingOptions = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            paddingBlock: "4rem"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "page__content",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    color: "#3A3E50",
                    fontWeight: 600,
                    fontSize: {
                        xs: 26,
                        lg: 44
                    },
                    textAlign: "center",
                    mb: 3,
                    lineHeight: 1,
                    component: "h2",
                    children: "Get Started With The Right Advantage"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    container: true,
                    children: pricingOptions.map(function(option, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            xs: 12,
                            sm: 12,
                            md: 6,
                            sx: {
                                pr: {
                                    xs: 0,
                                    md: index % 2 === 0 ? 2 : 0
                                }
                            },
                            pb: 2,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                sx: {
                                    backgroundColor: "#fff",
                                    boxShadow: "0px 0px 40px 0px #0017721A",
                                    borderRadius: "20px",
                                    p: 3
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        fontSize: {
                                            xs: 8,
                                            lg: 12
                                        },
                                        fontWeight: 700,
                                        textTransform: "uppercase",
                                        color: "#fff",
                                        sx: {
                                            backgroundColor: "#0F5D85",
                                            display: "inline-block",
                                            borderRadius: "30px",
                                            p: 1,
                                            letterSpacing: "2px"
                                        },
                                        children: option.badge
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        color: "#002E33",
                                        fontWeight: 600,
                                        fontSize: {
                                            xs: 18,
                                            lg: 24
                                        },
                                        my: 1,
                                        component: "h3",
                                        children: option.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        color: "#1D2935",
                                        fontWeight: 500,
                                        fontSize: {
                                            xs: 12,
                                            lg: 16
                                        },
                                        mb: 2,
                                        lineHeight: 1.3,
                                        children: option.description
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: option.items.map(function(item) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 1,
                                                mb: 1,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: "/assets/images/icon.png",
                                                        alt: "Icon",
                                                        width: "24px",
                                                        height: "24px"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        color: "#1D2935",
                                                        fontWeight: 500,
                                                        fontSize: {
                                                            xs: 12,
                                                            lg: 16
                                                        },
                                                        lineHeight: 1.3,
                                                        children: item
                                                    })
                                                ]
                                            }, item);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: option.link,
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryButton/* default */.Z, {
                                            sx: {
                                                px: 9,
                                                py: 2.25,
                                                mt: 1
                                            },
                                            children: "Register"
                                        })
                                    })
                                ]
                            })
                        }, option.title);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var home_PricingOptions = (PricingOptions);

;// CONCATENATED MODULE: ./src/ui/components/smart/landing/home/ProcurementOverview.tsx



var badgeColors = [
    "#0F5D85",
    "#005FCC"
];
var Item = function(param) {
    var item = param.item, isExpanded = param.isExpanded;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: {
            backgroundColor: "#fff",
            boxShadow: "0px 0px 40px 0px #0017721A",
            p: {
                xs: 2,
                sm: 2,
                md: 2,
                lg: 3,
                xl: 3
            },
            borderRadius: "20px",
            width: "100%",
            height: "100%"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            display: "flex",
            gap: 3,
            justifyContent: "space-between",
            height: "100%",
            sx: {
                flexDirection: {
                    xs: "column",
                    sm: "column",
                    md: "column",
                    lg: isExpanded ? "row" : "column"
                },
                xl: isExpanded ? "row" : "column"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    item: true,
                    xs: 12,
                    sm: 12,
                    md: 12,
                    lg: isExpanded ? 6 : 12,
                    xl: isExpanded ? 6 : 12,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            display: "flex",
                            gap: 1.5,
                            flexWrap: "wrap",
                            children: item.badges.map(function(badge, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    fontSize: {
                                        xs: 8,
                                        lg: 12
                                    },
                                    fontWeight: 700,
                                    textTransform: "uppercase",
                                    color: "#fff",
                                    sx: {
                                        backgroundColor: badgeColors[index % badgeColors.length],
                                        display: "inline-block",
                                        borderRadius: "30px",
                                        py: 1,
                                        px: 2,
                                        letterSpacing: "2px"
                                    },
                                    children: badge
                                }, badge);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            color: "#070A0D",
                            fontWeight: 600,
                            fontSize: {
                                xs: 18,
                                lg: 24
                            },
                            mt: 2,
                            mb: 1,
                            lineHeight: 1.25,
                            component: "h4",
                            children: item.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            color: "#1D2935",
                            fontSize: {
                                xs: 12,
                                lg: 16
                            },
                            fontWeight: 400,
                            children: item.description
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xs: 12,
                    sm: 12,
                    md: 12,
                    lg: isExpanded ? 6 : 12,
                    xl: isExpanded ? 6 : 12,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: item.image,
                        alt: item.title,
                        style: {
                            display: "block",
                            width: "100%",
                            height: "auto",
                            aspectRatio: "496 / 220",
                            borderRadius: "10px",
                            objectFit: "cover",
                            objectPosition: "center"
                        }
                    })
                })
            ]
        })
    });
};
var ProcurementOverview = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            paddingBlock: "4rem",
            marginBlock: "2rem",
            background: "linear-gradient(90deg, rgba(0, 149, 255, 0.05) 0%, rgba(255, 0, 140, 0.05) 49.04%, rgba(255, 166, 0, 0.05) 100%), linear-gradient(180deg, rgba(255, 255, 255, 0) 63.65%, #FFFFFF 100.78%), linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 46.54%)"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "page__content",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                    color: "#3A3E50",
                    fontWeight: 600,
                    fontSize: {
                        xs: 26,
                        lg: 44
                    },
                    textAlign: "center",
                    mb: 4,
                    mx: "auto",
                    maxWidth: "30ch",
                    lineHeight: 1,
                    component: "h3",
                    children: [
                        "End-to-End Procurement",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "One Seamless SaaS Solution"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    color: "#1D2935",
                    lineHeight: 1.5,
                    fontSize: {
                        xs: 12,
                        lg: 16
                    },
                    fontWeight: 400,
                    textAlign: "center",
                    maxWidth: "500px",
                    mx: "auto",
                    mb: 4,
                    children: "Gain full visibility, automate workflows, and connect instantly with buyers and sellers - all in one intuitive, AI-enhanced platform"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    container: true,
                    spacing: 3,
                    children: procurementOverviewItems.map(function(item, index) {
                        var isTwoCols = index % 3 !== 0;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            sm: 12,
                            md: 12,
                            lg: isTwoCols ? 6 : 12,
                            xl: isTwoCols ? 6 : 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                                item: item,
                                isExpanded: !isTwoCols
                            })
                        }, item.title);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var home_ProcurementOverview = (ProcurementOverview);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react-countup/build/index.js
var build = __webpack_require__(17857);
;// CONCATENATED MODULE: ./src/ui/components/smart/landing/home/Statistics.tsx






var CountProps = {
    color: "#005FCC",
    textAlign: "center",
    fontWeight: 800,
    fontSize: {
        xs: 30,
        lg: 58
    }
};
var DescriptionProps = {
    color: "#2C3E50",
    textAlign: "center",
    fontWeight: 600,
    fontSize: {
        xs: 11,
        lg: 16
    },
    maxWidth: "200px",
    mx: "auto",
    mt: 1,
    textTransform: "uppercase",
    lineHeight: 1.25
};
var GridItemProps = {
    xs: 6,
    md: 6,
    lg: 3,
    px: 1,
    py: 2
};
var borderStyles = "1px solid #D9E0E1";
// --- Values you want to display (also used for SSR) ---
var STATS = [
    {
        value: 10,
        suffix: "x",
        label: "Source-to-Pay Return on Investment"
    },
    {
        value: 90,
        suffix: "%",
        label: "First time match rate"
    },
    {
        value: 6500,
        suffix: "",
        label: "Purchase Orders per FTE"
    },
    {
        value: 30000,
        suffix: "",
        label: "Invoices per FTE"
    }, 
];
var Statistics = function() {
    // We detect client-side to run animation
    var ref = (0,react.useState)(false), isClient = ref[0], setIsClient = ref[1];
    (0,react.useEffect)(function() {
        setIsClient(true); // Enables animation after hydration
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            paddingBlock: "4rem"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "page__content",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    color: "#3A3E50",
                    fontWeight: 600,
                    fontSize: {
                        xs: 26,
                        lg: 44
                    },
                    textAlign: "center",
                    mb: 3,
                    lineHeight: 1,
                    component: "h2",
                    children: "Real Results, Real ROI"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    container: true,
                    children: STATS.map(function(item, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, GridItemProps), {
                            sx: {
                                borderRight: {
                                    xs: i % 2 === 0 ? borderStyles : "none",
                                    md: i % 2 === 0 ? borderStyles : "none",
                                    lg: i < 3 ? borderStyles : "none"
                                },
                                borderBottom: {
                                    xs: i < 2 ? borderStyles : "none",
                                    md: i < 2 ? borderStyles : "none",
                                    lg: "none"
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, CountProps), {
                                    children: isClient ? /*#__PURE__*/ (0,jsx_runtime.jsx)(build/* default */.ZP, {
                                        end: item.value,
                                        duration: 2.5,
                                        enableScrollSpy: true,
                                        scrollSpyOnce: true,
                                        suffix: item.suffix,
                                        separator: ","
                                    }) : // SSR fallback for SEO
                                    "".concat(item.value.toLocaleString()).concat(item.suffix)
                                })),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, DescriptionProps), {
                                    children: item.label
                                }))
                            ]
                        }), i);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var home_Statistics = (Statistics);

// EXTERNAL MODULE: ./src/ui/components/smart/landing/layout/LandingLayout.tsx + 2 modules
var LandingLayout = __webpack_require__(28140);
;// CONCATENATED MODULE: ./src/pages/index.tsx













var Home = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMetaHead/* default */.Z, {
                page_meta: {
                    title: "AI-Powered Procurement Solutions for Modern Businesses",
                    description: "Streamline your procurement process with AI-driven solutions, Automate tendering, sourcing, contract approvals, and supplier management using smart SaaS software."
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "page",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(home_HomeHero, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(home_CategoriesSlider, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "anchor",
                        id: "how-it-works"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(home_HowItWorks, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(home_Statistics, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(home_PricingOptions, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(home_IntelligentProcurement, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(home_ProcurementOverview, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(home_CategoriesSliderAsCards, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(home_HomeBlogPosts, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(home_Faq, {})
                ]
            })
        ]
    });
};
Home.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingLayout/* default */.Z, {
        children: page
    });
};
/* harmony default export */ var pages = (Home);


/***/ }),

/***/ 87333:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_icons_material_ArrowRightAlt__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(57354);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93789);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29630);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(54225);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var src_site_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29951);






var BlogPostCard = function(param) {
    var post = param.post;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        sx: {
            backgroundColor: "#fff",
            borderRadius: "20px",
            boxShadow: "0px 0px 40px 0px #0017721A",
            p: 2,
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: "".concat(post.cover_photo_path, "?v=").concat(post.id),
                        alt: post.photo_alt_text,
                        style: {
                            display: "block",
                            borderRadius: "10px",
                            objectFit: "cover",
                            objectPosition: "center",
                            width: "100%",
                            height: "175px"
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        fontSize: {
                            xs: 8,
                            lg: 11
                        },
                        fontWeight: 700,
                        textTransform: "uppercase",
                        color: "#fff",
                        sx: {
                            backgroundColor: "#0F5D85",
                            borderRadius: "30px",
                            display: "inline-block",
                            py: 1,
                            px: 2,
                            letterSpacing: "2px",
                            my: 2
                        },
                        children: moment__WEBPACK_IMPORTED_MODULE_1___default()(post.published_at, "DD-MM-YYYY").format("ll")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        color: "#070A0D",
                        fontWeight: 600,
                        fontSize: {
                            xs: 16,
                            lg: 20
                        },
                        lineHeight: 1.25,
                        component: "h3",
                        sx: {
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: 3,
                            overflow: "hidden"
                        },
                        children: post.title
                    }),
                    post.sub_title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        color: "#1D2935",
                        fontWeight: 400,
                        fontSize: {
                            xs: 12,
                            lg: 16
                        },
                        lineHeight: 1.25,
                        mt: 1,
                        sx: {
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: 3,
                            overflow: "hidden"
                        },
                        children: post.sub_title
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                display: "flex",
                justifyContent: "end",
                mt: 2,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                    href: src_site_map__WEBPACK_IMPORTED_MODULE_3__.sm.blog.post(post.slug).url,
                    passHref: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        type: "button",
                        endIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_ArrowRightAlt__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {}),
                        sx: {
                            color: "#0F5D85",
                            fontWeight: 600
                        },
                        children: "Read This Article"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BlogPostCard);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5079,6893,8140,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);